import React from 'react';
import { Grid, Row } from 'react-bootstrap';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../store/LoginActionsReducers';
import { withRouter } from 'react-router-dom';

import NavMenu from './NavMenu';
import api from '../ApiService';
// https://github.com/fkhadra/react-toastify
import { ToastContainer, Slide } from 'react-toastify';

class Layout extends React.Component {
    componentDidMount = () => {
        this.updateLastLoginDate();
        window.addEventListener('message', this.handleOneClickExport);
    }

    componentWillUnmount = () => {
        window.removeEventListener('message', this.handleOneClickExport);
    }

    updateLastLoginDate = () => {
        api.updateLastLoginDate();
        setInterval(() => {
            api.updateLastLoginDate();
        }, 1000 * 60 * 15);
    }

    // Receives CSV exports from the OneClickExport Power BI custom visual.
    // Visual posts to window.top because it's sandboxed inside Power BI's iframe.
    handleOneClickExport = async (event) => {
        const data = event && event.data;
        if (!data || data.type !== 'ONE_CLICK_EXPORT') return;
        if (typeof data.csv !== 'string') return;

        const filename = (typeof data.filename === 'string' && data.filename) || 'export.csv';
        const requestId = data.requestId || null;
        const source = event.source;

        const reply = (status, reason) => {
            if (!source || typeof source.postMessage !== 'function') return;
            try {
                source.postMessage({ type: 'ONE_CLICK_EXPORT_RESULT', requestId, status, reason }, '*');
            } catch (e) { /* sender gone */ }
        };

        const blob = new Blob([data.csv], { type: 'text/csv;charset=utf-8' });

        // Modern path: real Save As dialog so the user picks where the file lands.
        if (typeof window.showSaveFilePicker === 'function') {
            try {
                const handle = await window.showSaveFilePicker({
                    suggestedName: filename,
                    types: [{ description: 'CSV', accept: { 'text/csv': ['.csv'] } }]
                });
                const writable = await handle.createWritable();
                await writable.write(blob);
                await writable.close();
                reply('saved');
            } catch (err) {
                if (err && err.name === 'AbortError') {
                    reply('cancelled');
                } else {
                    reply('error', (err && err.message) ? err.message : String(err));
                }
            }
            return;
        }

        // Fallback for browsers without showSaveFilePicker (Safari/Firefox):
        // anchor-click goes to the browser's default download folder.
        try {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
            reply('saved');
        } catch (err) {
            reply('error', (err && err.message) ? err.message : String(err));
        }
    }
    render() {
        let year = new Date().getFullYear();
        return (
            <Grid fluid className="site-container">
                <Row className="site-content">
                    <NavMenu />
                    <div style={{ marginLeft: '20px', marginRight: '20px' }}>
                        {this.props.children}
                    </div>
                </Row>

                <footer className="site-footer align-middle">
                    <span>&copy; {year} iVET360 &middot; All rights reserved.</span>
                    {this.props.isAuthenticated &&
                        <span className="footer-links">
                            <a href="https://ivet360.com/financial-upload" className="plain-link" target="_blank" rel="noopener noreferrer">Financial Upload</a>
                            <a href="https://ivet360.com/pulse/user" className="plain-link" target="_blank" rel="noopener noreferrer">User Change Request</a>
                            <a href="https://ivet360.com/pulse/training/" className="plain-link" target="_blank" rel="noopener noreferrer">Training</a>
                        </span>
                    }
                </footer>

                <ToastContainer
                    transition={Slide}
                    position="bottom-center"
                    hideProgressBar
                    autoClose={2000}
                    pauseOnHover
                    closeOnClick
                />
            </Grid >);
    }
}

export default withRouter(connect(state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Layout));


// WEBPACK FOOTER //
// ./src/components/Layout.js